export type TimeRangeButton = {
  value: string;
  label: string;
  default?: boolean;
};
export const TABLE_ROW_HEIGHT_PX = 24;
export const DEFAULT_CHART_HEIGHT = 450;
export const MAX_SELECTED_SYMBOLS = 40;
export const MAX_SELECTED_CURVES = 2;
export const fullScreenChartPalette = [
  '#2D5BFF',
  '#7B61FF',
  '#FF6B2C',
  '#1AB394',
  '#9C27B0',
  '#D32F2F',
  '#996B21',
  '#20B15A',
  '#0597AE',
  '#E83A95'
];
export const regularChartPalette = [
  '#00BFFF',
  '#6363DF',
  '#F3733F',
  '#2E8B57',
  '#5284FF',
  '#E4597B',
  '#F8AE12',
  '#53F247',
  '#7FD4B6',
  '#FFD700',
  '#A20ECA',
  '#EEB280',
  '#1DD1A1',
  '#FFB700',
  '#00FE88',
  '#FFF280'
];
export const GX_TOKEN_STORAGE_ATTRIBUTE_NAME = 'gxToken';
export const CACHED_TOKEN_STORAGE_ATTRIBUTE_NAME = 'cacheToken';
export const TRIP_TOKEN_STORAGE_ATTRIBUTE_NAME = 'tripToken';
export const IMPERSONATOR_STORAGE_ATTRIBUTE_NAME = 'impersonator';
export const PATHNAME_STORAGE_ATTRIBUTE_NAME = 'lastPathname';
export const SHOW_SELECTED_URL_PARAM = 'showSelected';
export const SPOT_CATALOG_PATH = 'spot';
export const FWDCURVE_CATALOG_PATH = 'fwd';

export const METADATA_TERMS_FIELD = 'terms';
export const METADATA_FIRST_NAME_FIELD = 'hs_firstname';
export const METADATA_LAST_NAME_FIELD = 'hs_lastname';
export const METADATA_COMPANY_NAME_FIELD = 'hs_company_name';

const createOption = (label: string, value: string) => ({ label, value });

export const dateFormatOptions = [
  createOption('14-Mar-25', 'dd-MMM-yy'),
  createOption('03/14/2025', 'MM/dd/yyyy'),
  createOption('14/03/2025', 'dd/MM/yyyy'),
  createOption('2025-03-14', 'yyyy-MM-dd')
];
export const DEFAULT_TIME_RANGE_BUTTONS: TimeRangeButton[] = [
  { label: 'MTD', default: true, value: '1m' },
  { label: '3m', value: '3m' },
  { label: 'YTD', value: '1y' },
  { label: 'Max', value: 'all' }
];
export const MIN_DATE_RANGE = '1970-01-01T00:00:00.000Z';

export const timezones = [
  'America/Chicago',
  'America/Denver',
  'America/Edmonton',
  'America/Los_Angeles',
  'America/New_York',
  'America/Toronto',
  'America/Vancouver',
  'Asia/Dubai',
  'Asia/Riyadh',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Tokyo',
  'Europe/London',
  'Europe/Paris',
  'UTC'
];

export const SUPPORT_EMAIL = 'support@general-index.com';
export const TERMS_VERSION = 'GXC100024';

export const DEFAULT_INDEX_GROUP = 'Prod_Indexes';
export const API_SYNC_DELAY_MS = 2000;
export const QUERY_CACHE_TIME_MS = 60 * 60 * 1000;
